<template>
	<c-modal @close="close" :title="'Nieuwe rol'">
		
		<c-form ref="form" @valid="submit" class="margin-t-40">

			<c-input 
				type="text" 
				name="role-title"
				v-model="roleTitle"
				:label="'Titel'"
				:horizontal="true"
				required/>

			<c-input 
				type="text" 
				name="role-description"
				v-model="roleDescription"
				:label="'Omschrijving'"
				:horizontal="true"
				required/>

			<div class="row collapse align-right">
				<div class="columns shrink">
					<c-button class="margin-t-32 margin-b-16 no-margin-b" type="submit">Rol aanmaken</c-button>
				</div>
			</div>

		</c-form>

	</c-modal>
</template>

<script>
import Form from '@mixins/Form';
import CModal from '@components/Modal';

import { mapState } from 'vuex';
import { ValidationError } from '@app/errors';

export default {
	mixins: [Form],
	components: {
		CModal,
	},
	props: {
		edit: {
			required: false
		},
		role: {
			required: false
		}
	},
	data() {
		return {
			roleTitle: '',
			roleDescription: ''
		};
	},
	watch: {
	},
	methods: {
		submit() {

			let data = {
				name: this.roleTitle,
				description: this.roleDescription
			}

			if(this.edit)
			{
				this.$xhr.put('/api/roles/' + this.role.id, data).then( ( {result}) => {
					this.close();
					this.$store.dispatch('toast/success', {title: 'Rol wijzigen', text: 'De rol is gewijzigd'});
				}).catch( (e) => {
                    if (e instanceof ValidationError) {
                        this.$refs.form.setErrors(e.errors);
                    }
					this.$store.dispatch('toast/alert', {title: 'Rol wijzigen', text: 'De rol is niet opgeslagen'});
				});
			}
			else
			{
				this.$xhr.post('/api/roles', data).then( ( {result}) => {
					this.close();
					this.$emit('added');
					this.$refs.form.reset();
					this.$store.dispatch('toast/success', {title: 'Rol aanmaken', text: 'De rol is aangemaakt'});
				}).catch( (e) => {
                    if (e instanceof ValidationError) {
                        this.$refs.form.setErrors(e.errors);
                    }
					this.$store.dispatch('toast/alert', {title: 'Rol aanmaken', text: 'De rol is niet opgeslagen'});
				});
			}

			
		},
		close() {
			this.$emit('close');
		},
	},
	mounted() {

		if(this.edit){
			this.roleTitle = this.role.name;
			this.roleDescription = this.role.description;
		}
	}
}
</script>